module.exports = __webpack_public_path__ + "static/media/prize3_without_num.0084ad5a.svg";